import React, { Component } from 'react';
import Fade from 'react-reveal/Fade';
import { Link } from 'react-router-dom';
import { Grid, Row, Col, Tab, Tabs } from 'react-bootstrap';
import './About.css';
import logofile from '../../media/Distilled-ID-Logos.zip';

class About extends Component {
  componentDidMount() {
    this.scrollToMediaKit();
  }

  componentDidUpdate() {
    this.scrollToMediaKit();
  }

  scrollToMediaKit() {
    const { hash } = this.props.location;
    if (hash === '#media-kit') {
      setTimeout(
        () =>
          this.mediakit.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest',
          }),
        0
      );
    }
  }

  render() {
    return (
      <div className="about">
        <Grid fluid>
          <Fade delay={200}>
            <Row className="what-we-do">
              <Col md={12}>
                <h1 className="page-title"> What we do</h1>
              </Col>
              <Col md={7} className="header">
                <h3 className="page-description">
                  Distilled ID is a distillery management platform that helps
                  you control, not just your operation, but your entire product
                  lifecycle. Powered by arc-net’s unique blockchain-backed
                  technology, Distilled ID provides a means to first build your
                  story before sharing it with your customers.
                </h3>
                <p>
                  The Distilled ID platform makes it easy for you to track the
                  state of your distillery operation from grain to glass with
                  simple but effective features from stock and dry goods
                  management through to cask management and storage.
                </p>
                <p>
                  By storing your operational data on a private blockchain you
                  can be fully confident that the integrity and validity of the
                  information is secure and you can share that trust with the
                  people buying your products.
                </p>
                <h2 className="page-heading"> Why we do it </h2>
                <p>
                  Distilled ID was born from a desire to protect supply chains
                  and prevent counterfeiting and parallel trading. From this,
                  relatively ambitious origin, we have grown into a full
                  end-to-end distillery management platform. Our true value add
                  however, comes from our unique ability to connect your
                  products to your customers in previously impossible ways and
                  to utilise that bond to help you build up information then
                  allowing you to market your brand in new and exciting ways.
                </p>
              </Col>
              <Col md={4} mdOffset={1} className="milestones-container">
                <h5>Milestones</h5>
                <div className="milestones">
                  <p>
                    <span>Founded November 2014</span>, supported by the
                    Scottish Enterprise developed Entrepreneurial Spark program.
                  </p>
                  <p>
                    <span>June 2016</span> - Development of blockchain based
                    platform begins.
                  </p>
                  <p>
                    <span>December 2016 </span>- Arc-net secures 2M in funding
                    and Richard Steeves joins the team. Focus on Food supply
                    chains naturally progressed into the Beverage sector.
                  </p>
                  <p>
                    <span>December 2017 </span>- The world’s first “Blockchain
                    Beer”, Ireland Craft Beer’s Downstream is released.
                  </p>
                  <p>
                    <span>August 2018</span> - Company relocates entirely to
                    Edinburgh.
                  </p>
                  <p>
                    Both ranges have expanded supporting a varied range
                    of Whiskies and Beers.
                  </p>
                  <p>
                    <span>September 2018</span> - Distilled ID is born.
                  </p>
                  <p>
                    <span>December 2018</span> - New offices opened in Edinburgh
                    West-End.
                  </p>
                </div>
              </Col>
            </Row>
          </Fade>

          <Row>
            <div className="our-team">
              <Fade delay={100}>
                <div className="featured img-1" />
              </Fade>
              <Fade delay={500}>
                <div className="featured img-2" />
              </Fade>
              <Fade>
                <div className="featured img-3" />
              </Fade>
              <Fade delay={300}>
                <div className="featured img-4" />
              </Fade>
              <Fade delay={900}>
                <div className="featured img-5" />
              </Fade>
              <Fade delay={700}>
                <div className="featured img-6" />
              </Fade>
            </div>
          </Row>
          <Fade>
            <Row className="our-values">
              <Col>
                <h3>Our values</h3>
                <Tabs defaultActiveKey={1} id="tabs">
                  <Tab
                    eventKey={1}
                    title={
                      <span>
                        <i className="integrity values-icon" />{' '}
                      </span>
                    }
                  >
                    <h5>Integrity</h5>
                    <p>
                      We are transparent and open. We offer trust to our
                      partners and assume it from them.
                    </p>
                  </Tab>
                  <Tab
                    eventKey={2}
                    title={
                      <span>
                        <i className="community values-icon" />{' '}
                      </span>
                    }
                  >
                    <h5>Community</h5>
                    <p>
                      We are our team - a small company must believe in its
                      people and give them the opportunity to help us all
                      succeed.
                    </p>
                  </Tab>
                  <Tab
                    eventKey={3}
                    title={
                      <span>
                        <i className="curiosity values-icon" />{' '}
                      </span>
                    }
                  >
                    <h5>Curiosity</h5>
                    <p>
                      We always seek to learn and use what {"we've"} learned to
                      improve. Creativity and the user experience are at the
                      forefront of our offering.
                    </p>
                  </Tab>
                  <Tab
                    eventKey={4}
                    title={
                      <span>
                        <i className="tenacity values-icon" />{' '}
                      </span>
                    }
                  >
                    <h5>Tenacity</h5>
                    <p>
                      We are persistent and determined. We strive to compete at
                      the highest levels and are committed to producing precise,
                      fit for purpose solutions.
                    </p>
                  </Tab>
                  <Tab
                    eventKey={5}
                    title={
                      <span>
                        <i className="excellence values-icon" />{' '}
                      </span>
                    }
                  >
                    <h5>Excellence</h5>
                    <p>
                      Every one of our values contributes towards the excellence
                      in our products. Attention to detail and close
                      collaboration allows us to deliver the very best to our
                      customers.
                    </p>
                  </Tab>
                </Tabs>
              </Col>
            </Row>
          </Fade>
          <Row className="discover-team">
            <Col md={12} className="team-heading">
              <h1>The team @ Distilled ID</h1>
              <h3>
                Meet our talented team of creatives, techies and magic makers
              </h3>
            </Col>
            <Col md={12} className="about-team">
              <Fade delay={100}>
                <div className="featured img-1" />
              </Fade>
              <Fade delay={300}>
                <div className="featured img-2" />
              </Fade>
              <Fade delay={500}>
                <div className="featured img-3" />
              </Fade>
              <Fade delay={100}>
                <div className="featured img-4" />
              </Fade>
              <Fade delay={300}>
                <div className="featured img-5" />
              </Fade>
              <Fade delay={500}>
                <div className="featured img-6" />
              </Fade>
              <Fade delay={100}>
                <div className="featured img-7" />
              </Fade>
              <Fade delay={300}>
                <div className="featured img-8" />
              </Fade>
              <Fade delay={500}>
                <div className="featured img-9" />
              </Fade>
            </Col>
            <Col md={6} mdOffset={3} className="work-with-us">
              <Fade>
                <h3>
                  Interested in joining the team and helping us develop a great
                  culture? Check out all our openings and help shape the future
                  of drinks industry from the heart of Edinburgh
                </h3>
              </Fade>
              <Fade delay={200}>
                <Link to="/careers" className="blue-link">
                  View current openings →{' '}
                </Link>
              </Fade>
            </Col>
          </Row>
          <Fade>
            <Row className="media-kit">
              <Col>
                <div
                  ref={(r) => {
                    this.mediakit = r;
                  }}
                >
                  <h3>Our media kit</h3>
                  <p>
                    All content downloaded from this site may be used for
                    editorial purposes only. For additional media asset
                    inquiries, refer to our{' '}
                    <Link to="/contact" className="contact">
                      Contact
                    </Link>{' '}
                    page.
                  </p>
                </div>
                <a href={logofile} download="Distilled ID" className="download">
                  {' '}
                  Download
                </a>
              </Col>
            </Row>
          </Fade>
        </Grid>
      </div>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/components/views/About.js